import { render, staticRenderFns } from "./DetailClass.vue?vue&type=template&id=0e8eed8a&scoped=true"
import script from "./DetailClass.vue?vue&type=script&lang=js"
export * from "./DetailClass.vue?vue&type=script&lang=js"
import style0 from "./detailClass.css?vue&type=style&index=0&id=0e8eed8a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8eed8a",
  null
  
)

export default component.exports